<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>支付配置</span>
        <el-button 
          v-if="smallWeChatManageInfo.smallWeChats.length === 0"
          type="primary" 
          size="small" 
          @click="_openAddSmallWeChatModal(1100)"
          style="float: right; padding: 3px 0"
        >
          <i class="el-icon-plus"></i>添加
        </el-button>
      </div>

      <el-table
        :data="smallWeChatManageInfo.smallWeChats"
        style="width: 100%"
        border
        stripe
      >
        <el-table-column
          prop="name"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="payPassword"
          label="支付密码"
          align="center"
        >
          <template >
            **********
          </template>
        </el-table-column>
        <el-table-column
          prop="mchId"
          label="商户ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="mchName"
          label="商户名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remarks"
          label="描述"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="_openEditSmallWeChatModel(scope.row)"
            >修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <add-small-we-chat ref="addSmallWeChat"></add-small-we-chat>
    <edit-small-we-chat ref="editSmallWeChat"></edit-small-we-chat>
  </div>
</template>

<script>
import { listSmallWeChats } from '@/api/goods/smallWeChatApi'
import { getShopId } from '@/api/shop/shopApi'
import AddSmallWeChat from '@/components/goods/addSmallWeChat/addSmallWeChat.vue'
import EditSmallWeChat from '@/components/goods/editSmallWeChat/editSmallWeChat.vue'

export default {
  name: 'PublicWeChatManage',
  components: {
    AddSmallWeChat,
    EditSmallWeChat
  },
  data() {
    return {
      smallWeChatManageInfo: {
        smallWeChats: [],
        total: 0,
        records: 1,
        moreCondition: false,
        name: '',
        wetConfig: false,
        conditions: {
          name: '',
          appId: '',
          weChatType: '1100',
          shopId: ''
        }
      }
    }
  },
  created() {
    this.smallWeChatManageInfo.conditions.shopId = getShopId()
    this._listSmallWeChats(1, 15)
  },
  methods: {
    _listSmallWeChats(page, rows) {
      this.smallWeChatManageInfo.conditions.page = page
      this.smallWeChatManageInfo.conditions.row = rows
      this.smallWeChatManageInfo.conditions.shopId = getShopId()
      
      listSmallWeChats(this.smallWeChatManageInfo.conditions)
        .then(response => {
          this.smallWeChatManageInfo.smallWeChats = response.data
          if (this.smallWeChatManageInfo.smallWeChats.length > 0) {
            this.$emit('wechatAttrInfo', 'getWechatAttrInfo', {
              wechatId: this.smallWeChatManageInfo.smallWeChats[0].weChatId,
              wId: this.smallWeChatManageInfo.smallWeChats[0].wId
            })
          }
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    _openAddSmallWeChatModal(type) {
      this.$refs.addSmallWeChat.open(type)
    },
    _openEditSmallWeChatModel(smallWeChat) {
      this.$refs.editSmallWeChat.open(smallWeChat)
    },
    _querySmallWeChatMethod() {
      this._listSmallWeChats(1, 15)
    },
    _switchWeChatType(type) {
      this.smallWeChatManageInfo.conditions.weChatType = type
      this._listSmallWeChats(1, 15)
    },
    _openWeChatMenu(smallWeChat) {
      console.log(smallWeChat)
      this.$router.push('/pages/property/wechatMenuManage')
    },
    _openWeChatSmsTemplate(smallWeChat) {
      console.log(smallWeChat)
      this.$router.push(`/pages/property/wechatSmsTemplateManage?wechatId=${smallWeChat.wechatId}`)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 20px;
}
</style>